import { setupTelegramColors } from './setupTelegramColors';
import { setupTelegramViewport } from './telegramViewport';

const safeExec = (fn: () => void): void => {
  try {
    fn();
  } catch (error) {
    console.warn('Error:', error);
  }
};

/**
 * Telegram-specific setup and utilities. This file is intended to be an entry point for all Telegram-related initialization logic,
 * such as setting up colors, viewport, and other WebApp features.
 */
export function setupTelegram(): void {
  const webapp = window?.Telegram?.WebApp;
  if (!webapp) return;

  // Disable vertical swipes to prevent accidental closing of the WebApp
  safeExec(() => webapp.disableVerticalSwipes());

  // Expand WebApp to full height on launch (especially for iOS)
  safeExec(() => webapp.expand());

  // Fullscreen mode is a desired option from UX/UI perspective
  safeExec(() => webapp.requestFullscreen());

  // Set colors for Telegram WebView (Background, title)
  setupTelegramColors();

  // Синхронизация высоты viewport с Telegram (iOS/Android)
  setupTelegramViewport();
}
